import Constants from "../constants/constants";
import socketIOClient from "socket.io-client";

const ENDPOINT = Constants.GAME_SERVER_URL;

export const actions = {
    gotRoomList: "GOT_ROOM_LIST"
}

const socket = socketIOClient(ENDPOINT, {transports: ['websocket']});

export function getRoomList(){
    socket.emit("roomListSub");
    return dispatch => {
        socket.on('roomList' , function (roomList) {
            //DISPATCH HERE!
            dispatch({
                type: actions.gotRoomList,
                data: roomList
            })
        });
    }
}

const INITIAL_STATE = {
    roomList: []
}

export default function reducer(state = INITIAL_STATE, action){
    switch(action.type){
        case actions.gotRoomList:
            return {
                ...state,
                roomList: [...action.data]
            }
        default:
            return {...state};
    }
}


// WEBPACK FOOTER //
// ./src/modules/restore_together.js